<template>
  <b-container class="mt-5">
    <b-row>
      <b-col cols="12">
        <!-- <h2>Login</h2> -->
        <b-alert
          show
          variant="warning"
          v-if="error"
        >
          <h4 class="alert-heading">Error!!!</h4>
          <p>Oops!!!!, it appears that your username and password are not valid, please try again or contact support</p>
        </b-alert>
        <div>
          <Logo :logoProps="logo" />
          <b-form
            @submit.stop.prevent="onSubmit"
            class="forms mt-4"
          >
            <b-form-group
              class="group mb-3"
              label="Username"
              label-cols-sm="4"
              label-cols-lg="3"
              label-for="username"
            >
              <b-form-input
                type="email"
                v-model="$v.form.username.$model"
                name="username"
                placeholder="eg. username@ethixbase.com"
                class="form-control"
                :class="{ 'is-invalid': submitted && !form.username }"
                :state="$v.form.username.$dirty ? !$v.form.username.$error : null"
                aria-describedby
              />
              <b-form-invalid-feedback v-show="submitted && !form.username">Username is required.</b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              class="group mb-3"
              label="Password"
              label-cols-sm="4"
              label-cols-lg="3"
              label-for="password"
            >
              <b-form-input
                type="password"
                v-model="$v.form.password.$model"
                name="password"
                placeholder="**********"
                class="form-control"
                @keyup.enter="onSubmit()"
                :class="{ 'is-invalid': submitted && !form.password }"
                :state="$v.form.password.$dirty ? !$v.form.password.$error : null"
                aria-describedby
              />
              <b-form-invalid-feedback v-show="submitted && !form.password">Password is required.</b-form-invalid-feedback>
            </b-form-group>
            <div>
              <b-button
                class="btn"
                type="submit"
                :disabled="$v.form.$invalid"
              >
                <b-spinner
                  v-if="submitted"
                  type="grow"
                  label="Loading..."
                ></b-spinner>Login
              </b-button>
              <router-link to="/forgot">Forgot Password</router-link>
            </div>
          </b-form>
          <div class="mt-5">
            <p>
              By logging in to the platform I agree to the
              <router-link to="#">Terms & Conditions</router-link> and
              <router-link to="#">Privacy & Cookie Policy</router-link>
            </p>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { Helper } from "../helpers";
import { HTTP } from "../utils/HTTP";
import uid from "uid";
import Cryptr from "cryptr";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import Logo from "../components/logo/logo.vue";
export default {
  name: "LoginPage",
  mixins: [validationMixin],
  components: {
    Logo,
  },
  data () {
    return {
      logo: {
        width: "auto",
        height: "50px",
        class: "mt-2",
      },
      form: {
        username: null,
        password: null,
      },
      error: false,
      submitted: false,
      loggedIn: false,
    };
  },
  computed: {
    // ...mapState('account', ['status'])
  },
  created () {
    // reset login status
    //this.logout();
  },
  validations: {
    form: {
      username: {
        required,
        minLength: minLength( 5 ),
      },
      password: {
        required,
        minLength: minLength( 5 ),
      },
    },
  },
  mounted () { },
  methods: {
    onSubmit ( e ) {
      this.$v.form.$touch();
      if ( this.$v.form.$anyError ) {
        return;
      }

      const { username, password } = this.form;
      if ( username && password ) {
        this.onLogin( username, password );
      }
      this.submitted = true;
    },

    async onLogin ( username, password ) {
      const cryptr = new Cryptr( "myTotalySecretKey" );
      let loginData = {
        username,
        password,
      };

      if ( process.env.VUE_APP_APPLICATION == "employee" || process.env.VUE_APP_APPLICATION == "remington_seeds" ) {
        let employeeLoginData = {
          username,
          password,
          userAgent: navigator.userAgent,
        };
        let response = await HTTP( "post", "login", employeeLoginData );
        try {
          if ( response.data.accessToken ) {
            this.$store.commit( "SET_ACCESS_TOKEN", response.data.accessToken );
            localStorage.setItem("accessToken", response.data.accessToken);
            localStorage.setItem(
              "userType",
              response.data.userDetail.user_type
            );
            localStorage.setItem(
              "employeeId",
              response.data.userDetail.employee_id
            );
            localStorage.setItem( "userId", response.data.userDetail.id );
            let userData = JSON.stringify( response.data.userDetail );
            localStorage.setItem( "userDetail", userData );
            localStorage.setItem( 'showSidebar', '1' );
            this.loggedIn = true;
            if ( response.data.userDetail.update_password == "1" ) {
              window.location.href = "/update-password";
            } else {
              if ( response.data.userDetail.user_type == 3 ) {
              window.location.href = "/dashboard";
              } else if ( response.data.userDetail.user_type == 2 ) {
                this.$router.push( "/dashboard" );
              } else {
                this.$router.push( "/manage-employee" );
                // window.location.href = "/manage-employee";
              }
            }
          } else {
            this.submitted = false;
            this.error = true;
            this.loggedIn = false;
          }
        } catch ( error ) {
          this.form.username = null;
          this.form.password = null;
          this.submitted = false;
          Helper.makeToast( this.$bvToast, "danger", "Please Try Again Later" );
          return [error];
        }
      } else {
        let result = await HTTP( "post", "authenticate", loginData );
        if ( result && result.data.httpStatus == 200 ) {
          let token = result.data.authToken;
          let userId = result.data.memberId;
          let userGroupId = result.data.memberGroupId;
          let userFullname = result.data.userName || result.data.userFullname;
          let userEmail = result.data.email;
          let registrationStatus = parseInt( result.data.userRegistrationStatus );
          let userTourStatus = parseInt( result.data.userTourStatus );

          const encryptedString = cryptr.encrypt( userGroupId );
          const decryptedString = cryptr.decrypt( encryptedString );

          if ( token ) {
            localStorage.setItem( "accessToken", token );
            localStorage.setItem( "userId", userId );
            localStorage.setItem( "userGroupId", userGroupId );
            localStorage.setItem( "userFullname", userFullname );
            localStorage.setItem( "userEmail", userEmail );
            localStorage.setItem( "registrationStatus", registrationStatus );
            localStorage.setItem( "userTourStatus", userTourStatus );
            localStorage.setItem( "userFirstname", result.data.userFirstname );
            localStorage.setItem( "userLastname", result.data.userLastname );
            localStorage.setItem( "formDefaultLanguage", "english" );
            localStorage.setItem( "formTranslations", ["English"] );

            this.$socket.emit( "userId", userId );
            // for languages by default
            switch ( result.data.contact.language ) {
              case "zh-cn":
                // code block
                localStorage.setItem(
                  "formDefaultLanguage",
                  "chinese simplified"
                );
                break;
              case "ja":
                localStorage.setItem( "formDefaultLanguage", "japanese" );
                // code block
                break;
              case "es":
                localStorage.setItem( "formDefaultLanguage", "spanish" );
                break;
              default:
                // code block
                localStorage.setItem( "formDefaultLanguage", "english" );
            }
            if (
              result.data.formTranslations &&
              result.data.formTranslations.length
            ) {
              this.$store.state.form1.formTranslations =
                result.data.formTranslations;
              localStorage.setItem(
                "formTranslations",
                result.data.formTranslations
              );
            }
            switch ( process.env.VUE_APP_APPLICATION ) {
              case "pri":
                this.$router.push( "/pri-searches-control-groups" );
                break;
              case "remdiation":
                this.$router.push( "/remediation" );
                break;

              case "thirdparty":
                if ( userGroupId != 16 ) {
                  this.$router.push( "/templates" );
                } else if ( registrationStatus == 1 ) {
                  this.$router.push( "/dashboard" );
                } else {
                  this.$router.push( "/dashboard" );
                }

                break;

              default:
                if ( registrationStatus == 1 ) {
                  if ( userGroupId == 16 ) {
                    this.$router.push( "/dashboard" );
                  } else {
                    this.$router.push( "/templates" );
                  }
                } else {
                  this.$router.push( "/create-profile" );
                }
            }
          } else {
            this.submitted = false;
            this.form.username = null;
            this.form.password = null;
            this.error = true;
            this.loggedIn = false;
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn {
  float: right;
}
.row {
  display: block;
}
</style>
